import { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { Navigate } from "react-router-dom";
import { AuthContextType } from "../../contexts/AuthContextType";

export const Home = () => {
	const { currentUser } = useContext<AuthContextType>(AuthContext);
	return currentUser ? <Navigate to="/dashboard" /> : <Navigate to="/signin" />;
};
